import * as Icons from "lucide-react";
import { SECTION_META, GROUP_ORDER } from "./reviewMeta";
import { StatusDot } from "./StatusDot";

// review = { keys, activeK, statusOf, reviewedCount, reviewableCount, pendingCount }
export function ReviewChecklist({ review, onOpen }) {
  const { keys, activeK, statusOf, reviewedCount, reviewableCount, pendingCount } = review;
  return (
    <div data-testid="ca-checklist">
      <div className="flex items-center justify-between mb-3 px-1">
        <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Review Checklist</div>
        <span className="text-[11px] font-semibold text-slate-500" data-testid="ca-progress-text">{reviewedCount}/{reviewableCount}</span>
      </div>
      <div className="h-1.5 rounded-full bg-slate-100 mb-4 overflow-hidden">
        <div className="h-full bg-emerald-500 transition-all" style={{ width: `${reviewableCount ? (reviewedCount / reviewableCount) * 100 : 0}%` }} data-testid="ca-progress-bar" />
      </div>
      {GROUP_ORDER.map((group) => {
        const groupKeys = keys.filter((k) => SECTION_META[k].group === group);
        if (groupKeys.length === 0) return null;
        return (
          <div key={group} className="mb-4">
            <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-1.5 px-1">{group}</div>
            <div className="space-y-0.5">
              {groupKeys.map((k) => {
                const meta = SECTION_META[k];
                const st = statusOf(k);
                const isActive = k === activeK;
                const Icon = Icons[meta.icon] || Icons.FileText;
                return (
                  <button key={k} onClick={() => onOpen(k)} data-testid={`ca-nav-${k}`}
                    className={`w-full flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-left transition-colors ${isActive ? "bg-blue-50 ring-1 ring-blue-200" : "hover:bg-slate-50"}`}>
                    <StatusDot status={st} />
                    <Icon className={`h-3.5 w-3.5 shrink-0 ${isActive ? "text-blue-600" : "text-slate-400"}`} />
                    <span className={`flex-1 text-sm truncate ${isActive ? "font-semibold text-blue-900" : "text-slate-700"}`}>{meta.label}</span>
                    {k === "record_updates" && pendingCount > 0 && (
                      <span className="text-[10px] font-bold text-amber-700 bg-amber-100 rounded-full px-1.5 py-0.5">{pendingCount}</span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
